import "./product-details-title.scss";
import { EventBus, Events } from "jiffy-store";

const colorUpdateObserver = $context => {
  EventBus.on(Events.PRODUCT_COLOR_SELECTED, (evt, { color }) => {
    $context.textContent = color;
  });
};

export default () => {
  const $titleColorName = document.querySelector(`.js-product-details-title__color-name`);
  if (!$titleColorName) return;

  colorUpdateObserver($titleColorName);
};
